import { render, staticRenderFns } from "./SoftDrinks.vue?vue&type=template&id=bfc204e6&scoped=true&"
import script from "./SoftDrinks.vue?vue&type=script&lang=js&"
export * from "./SoftDrinks.vue?vue&type=script&lang=js&"
import style0 from "./SoftDrinks.vue?vue&type=style&index=0&id=bfc204e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc204e6",
  null
  
)

export default component.exports